import React from 'react';
import { Helmet } from 'react-helmet-async';
import { FaWhatsapp } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/Navbar';
import VolunteerRequestTrigger from '../components/VolunteerRequestTrigger';
import { useSiteSettings } from '../hooks/useSiteSettings';
import { whatsappHref, formatPhoneDisplay } from '../utils/contactLinks';
import './PublicSimplePages.css';

const VolunteerPage = () => {
  const { t } = useTranslation();
  const settings = useSiteSettings();
  const whatsappNumber = settings.whatsapp || settings.phone || '';
  const wa = whatsappHref(whatsappNumber);
  const waLabel = formatPhoneDisplay(whatsappNumber);

  return (
    <div className="public-simple-page">
      <Helmet>
        <title>{`${t('public.volunteerPage.metaTitle')} | ${t('public.brand.titleSuffix')}`}</title>
      </Helmet>
      <Navbar />
      <main className="public-simple-page__main">
        <h1>{t('public.volunteerPage.title')}</h1>
        <p className="public-simple-page__lead">
          {settings.volunteer_intro || t('public.volunteerPage.intro')}
        </p>
        <div className="public-simple-card">
          <h2>{t('public.volunteerPage.requestTitle')}</h2>
          <p className="public-simple-page__lead" style={{ marginBottom: '1rem' }}>
            {t('public.volunteerPage.requestLead')}
          </p>
          <VolunteerRequestTrigger className="public-simple-btn">
            {t('public.nav.volunteer')}
          </VolunteerRequestTrigger>
        </div>
        <div className="public-simple-card">
          <h2>{t('public.donatePage.whatsapp')}</h2>
          {wa ? (
            <>
              <p className="public-simple-whatsapp-number" dir="ltr">
                {waLabel}
              </p>
              <a className="public-simple-btn public-simple-btn--wa" href={wa} target="_blank" rel="noopener noreferrer">
                <FaWhatsapp /> {t('public.donatePage.whatsappCta')}
              </a>
            </>
          ) : (
            <p className="public-simple-page__muted">{t('public.donatePage.whatsappMissing')}</p>
          )}
        </div>
      </main>
    </div>
  );
};

export default VolunteerPage;
